export default __webpack_public_path__ + "static/media/icon-twitter.1d5c6d5e.svg";